import WallCommon from "./wallCommon";
import {createPageToLoadArray} from "../../constants";

export default class CenterWall extends WallCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_wall';
    this.partName = 'Center Wall';
    this.translateId = "visualizer.bathroom.walls.center_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    if (isChild) {
      createPageToLoadArray(this);
    }
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Background.CenterWall;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
    }
  }
}
